import React from 'react'
import './Join.css'
import { useTranslation } from 'react-i18next';

const Join = () => {
  const { t } = useTranslation();

  return (
    <section id='join'>
        <div className="container-fluid px-md-5 mt-5 pt-5 px-3">
            <div className="row mb-4">
                <div className="col-md-6">
                    <h4 className='section-suptitle'>{t('join.title')}</h4>
                </div>
                <div className="col-md-6">
                    <p className='section-desc w-100 mb-4'>{t('join.desc')}</p>
                </div>
            </div>
            <div className="row align-items-center rounded-top-circle join-float">
                <div className="col-md-3 order-1">
                    <h4 className='join-title mb-3'>{t('join.expert.title')}</h4>
                    <p className='side-desc w-100 mb-5'>{t('join.expert.desc')}</p>
                    <h4 className='join-title mb-3'>{t('join.success.title')}</h4>
                    <p className='side-desc w-100 mb-4'>{t('join.success.desc')}</p>
                </div>
                <div className="col-md-6 order-3 order-md-2">
                    <img src="main-join.png" className='img-fluid join-img' alt="join" />
                </div>
                <div className="col-md-3 order-2 order-md-3">
                    <h4 className='join-title mb-3'>{t('join.service.title')}</h4>
                    <p className='side-desc w-100 mb-5'>{t('join.service.desc')}</p>
                    <h4 className='join-title mb-3'>{t('join.industry.title')}</h4>
                    <p className='side-desc w-100 mb-4'>{t('join.industry.desc')}</p>
                </div>
                <div className="join-line order-4"></div>
            </div>
        </div>
    </section>
  )
}

export default Join
